const notEmptyStringValidator = (message = 'validators.requiredValidator') => ({
  validate: (value) => (String(value).trim().length ? true : message)
});

export default notEmptyStringValidator;
